import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@nazka/nazka.mapframe.components';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';

import TranslationsProvider from '@utils/i18n/i18n';
import WindowObserver from '@utils/WindowObserver/WindowObserver';
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary';
import Cookies from '@utils/Cookies/Cookies';

import translator from '@App/app.translator';

import AuthProvider from '@App/components/AuthProvider/AuthProvider';
import RegistrationConfirmationModal from '@App/components/RegistartionConfirmationModal/RegistrationConfirmationModal';

import theme from '@css/theme.style.json';

import queryClient from './app.query-client';
import routes from './app.routes';
import { setShowRegistrationConfirmationModal } from './app.slice';

import './app.styl';

const router = createBrowserRouter(routes);

function App() {
  useEffect(() => document.documentElement.setAttribute('data-app-initialised', true), []);

  const showRegistrationConfirmationModal = useSelector(state => state.app.showRegistrationConfirmationModal);
  const dispatch = useDispatch();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <ErrorBoundary>
            <TranslationsProvider translator={translator}>
              <RouterProvider router={router} />
              <Cookies useConfig />
              {showRegistrationConfirmationModal && (
                <RegistrationConfirmationModal onClose={() => dispatch(setShowRegistrationConfirmationModal(false))} />
              )}
              <ToastContainer />
            </TranslationsProvider>
          </ErrorBoundary>
        </ThemeProvider>
        <WindowObserver />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export { queryClient };
export default App;
